"use strict";
/**
 * Component: AppDialog
 * Fitxer: AppDialog.tsx
 * Llenguatge: TypeScrypt
 * Autor: Jordi Riu
 * Versió: 1.1
 * Data: 05/04/2017
 * (c) Ajuntament de Manresa - abr 2017 - Departament de Sistemes d'Informació
 */

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var core_1 = require("@material-ui/core");

var mobx_react_1 = require("mobx-react");

var AppDialog =
/** @class */
function (_super) {
  __extends(AppDialog, _super);

  function AppDialog() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  AppDialog.prototype.render = function () {
    if (!this.props.appState) {
      return null;
    }

    var dialState = this.props.appState.dialState;

    if (!dialState.dialogs.length) {
      return null;
    }

    return React.createElement("div", null, dialState.dialogs.map(function (dialog, idxDialog) {
      // const dialogStyle = {padding: 0, ...dialog.style};
      return React.createElement(core_1.Dialog, {
        key: idxDialog,
        open: true,
        onClose: dialState.close,
        scroll: "paper",
        maxWidth: "md",
        fullWidth: true
      }, React.createElement(core_1.DialogTitle, null, dialog.title), React.createElement(core_1.DialogContent, null, dialog.message), React.createElement(core_1.DialogActions, null, dialog.buttons.map(function (accio, idxButton) {
        return React.createElement(core_1.Button, {
          key: idxButton,
          color: accio.primary ? 'primary' : accio.secondary ? 'secondary' : undefined,
          autoFocus: accio.default,
          variant: accio.variant,
          onClick: function onClick() {
            dialog.respon(accio.label);
          }
        }, accio.label);
      })));
    }));
  };

  AppDialog = __decorate([mobx_react_1.inject('appState'), mobx_react_1.observer], AppDialog);
  return AppDialog;
}(React.Component);

exports.default = AppDialog;